module.exports = __webpack_public_path__ + "media/public/images/slider/ajax-loader-fb6f3c230cb846e25247dfaa1da94d8f.gif";